/**
 * Config web Firebase pentru `spressjoy-staging`.
 * Folosit pe: localhost, spressjoy-staging.web.app / .firebaseapp.com, canale preview (*.web.app).
 */
export const firebaseStagingConfig = {
  apiKey: 'AIzaSyDay3R8lfViN_spR-cqsBkActmyicprboU',
  authDomain: 'spressjoy-staging.firebaseapp.com',
  projectId: 'spressjoy-staging',
  storageBucket: 'spressjoy-staging.firebasestorage.app',
  messagingSenderId: '234102479933',
  appId: '1:234102479933:web:ff45f34961d2cde84cde54'
};
